import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Heart } from "lucide-react";
import { useCart } from "../context/CartContext";

const LOGO = "https://customer-assets.emergentagent.com/job_brigadeiro-shop-10/artifacts/ro8wmkw2_Logo%20Confeitaria%20Divertido%20Rosa%20e%20Bege.png";

export default function Header() {
  const { totalCount, setOpen } = useCart();
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  if (isAdmin) return null;

  const NavLink = ({ to, children }) => (
    <Link
      to={to}
      data-testid={`nav-${to.replace(/\//g, "") || "home"}`}
      className={`text-sm tracking-wide uppercase transition-colors hover:text-rose-accent ${
        loc.pathname === to ? "text-rose-accent" : "text-cocoa-soft"
      }`}
    >
      {children}
    </Link>
  );

  return (
    <header className="sticky top-0 z-40 bg-cream/85 backdrop-blur-xl border-b border-cocoa/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src={LOGO} alt="Caseirinhos" className="w-12 h-12 rounded-full shadow-sm" />
          <div className="hidden sm:block">
            <div className="font-heading text-2xl text-cocoa-dark leading-none">Caseirinhos</div>
            <div className="font-accent text-rose-accent text-sm leading-none mt-1">feito com amor</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/">Início</NavLink>
          <NavLink to="/catalogo">Catálogo</NavLink>
          <NavLink to="/sobre">Sobre</NavLink>
        </nav>

        <div className="flex items-center gap-4">
          <Link to="/admin/login" data-testid="admin-login-link" className="hidden sm:flex items-center gap-1.5 text-xs uppercase tracking-widest text-cocoa-soft hover:text-rose-accent transition-colors">
            <Heart className="w-3.5 h-3.5" /> Admin
          </Link>
          <button
            data-testid="open-cart-button"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 bg-rose hover:bg-rose-hover text-cocoa-dark px-5 py-2.5 rounded-full font-medium transition-colors"
          >
            <ShoppingBag className="w-4 h-4" />
            <span className="text-sm">Cesto</span>
            {totalCount > 0 && (
              <span data-testid="cart-count" className="absolute -top-1 -right-1 bg-cocoa-dark text-cream w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-semibold">
                {totalCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
